import {AxiosResponse} from "axios";
import {axiosInstance} from "../utils/axiosInstance";
import type {AllNews} from "./types/news";
import {AllNewsFilter} from "./types/news";
import type {AllCategories, AllCategoriesFilter, SingleCategory} from "./types/singleCategory";

const mainEndpoint = 'categories'

// fetch all news
export async function fetchAllCategories(searchParams: AllCategoriesFilter): Promise<AxiosResponse<AllCategories>> {
    return await axiosInstance.get(mainEndpoint, {params: searchParams});
}

export async function fetchSingleCategory(id): Promise<AxiosResponse<SingleCategory>> {
    const endpoint = `/${id}`
    return await axiosInstance.get(`${mainEndpoint}${endpoint}`);
}

export async function createCategory(data): Promise<any> {
    return await axiosInstance.post(`${mainEndpoint}`, data)
}

export async function updateCategory(id, data): Promise<any> {
    const endpoint = `/${id}/`
    return await axiosInstance.put(`${mainEndpoint}${endpoint}`, data)
}